import React, { useEffect } from "react";
import { globalHistory } from "@reach/router";
import cx from "classnames";

type Props = {
  children: JSX.Element | JSX.Element[];
  className?: string;
  fixedHeader?: boolean;
};

Frame.defaultProps = {
  fixedHeader: true,
};

const Footer = () => {
  return (
    <footer className="flex flex-col w-full">
      {/* Copyright Section */}
      <div className="bg-black flex gap-2.5 items-center justify-center px-2.5 py-5 w-full">
        <p className="font-normal text-2xs text-right text-white w-full max-w-[1032px] px-10 xl:px-0">
          ©2025 Artefact Inc.
        </p>
      </div>
    </footer>
  );
};

function Frame({ children, className, fixedHeader }: Props) {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default Frame;
